import { motion } from "framer-motion";

function BlogCard({ date, link, title, delay, imgUrl }) {
  return (
    <motion.div
      exit={{ scale: 1 }}
      initial={{ scale: 0 }}
      animate={{ scale: 1 }}
      transition={{ duration: 0.3, delay }}
    >
      <div className="card w-auto group font-poppins mb-5 md:mb-0">
        <a href={link}>
          <figure className="overflow-hidden rounded-lg">
            <img
              alt="Blog"
              src={imgUrl}
              loading="lazy"
              className="transition-transform duration-500 group-hover:scale-110 w-full max-h-64 object-cover"
            />
          </figure>
        </a>
        <div className="card-body px-0 py-3">
          <p className="text-gray-300 text-sm">{date}</p>
          <div className="text-xl text-white card-title">{title}</div>
        </div>
      </div>
    </motion.div>
  );
}

export default BlogCard;
